import { MRT_ColumnDef } from "material-react-table";
import type { Job } from "../../../../../api/types";
import { ColumnContext, dateColumn } from "./standard-column-types";

export function column_EstimatedFieldReadyDate(context: ColumnContext): MRT_ColumnDef<Job, unknown> {
	return dateColumn(context, "dateFieldReadyEstimated", "dateFieldReadyEstimated", {
		customRequiredMessage: "Estimated field ready date is required",
	});
}
